import { Recurso } from "lib.common/dist/CleanArch";
import { ErrDevValidacion } from 'lib.common/dist/errorHandler';
import { EstadisticasDsKeyRepository } from "../../bussines/repositories/EstadisticasDsKeyRepository";
import { EstadisticasDsKeyDtSource } from "../../bussines/dataSources/EstadisticasDsKeyDtSource";
import { FechaParams } from "../../utils/params/FechaParams.params";
import { EstadisticasLlaveModel } from "../models/EstadisticasLlaveModel";
import { DataLlaveModel } from "../models/DataLlaveModel";
import { EstadoLlaveAnualModel } from "../models/EstadoLlaveAnualModel";
import { ResumenByClienteProductoUsuarioModel } from "../models/ResumenByClienteProductoUsuarioModel";
import { GetEstadoLlavesAnualParams } from "../../utils/params/EstadisticasDsKey.params";

export class EstadisticasDsKeyRepositoryImpl implements EstadisticasDsKeyRepository<EstadisticasLlaveModel, DataLlaveModel, EstadoLlaveAnualModel, ResumenByClienteProductoUsuarioModel> {
    private dataSource: EstadisticasDsKeyDtSource;

    constructor(dataSource: EstadisticasDsKeyDtSource) {
        this.dataSource = dataSource;
    }

    async getEstadisticasLlaves(input: FechaParams): Promise<Recurso<EstadisticasLlaveModel>> {
        try {
            const result = await this.dataSource.getEstadisticasLlaves(input);

            if (result.isSuccess()) {
                return Recurso.fromData<EstadisticasLlaveModel>(
                    EstadisticasLlaveModel.deserialize(result.data!)
                );
            }
            return Recurso.fromError<EstadisticasLlaveModel>(result.error!);
        } catch (error) {
            return Recurso.fromError<EstadisticasLlaveModel>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getLlavesAnuladasMes(input: FechaParams): Promise<Recurso<DataLlaveModel[]>> {
        try {
            const result = await this.dataSource.getLlavesAnuladasMes(input);

            if (result.isSuccess()) {
                return Recurso.fromData<DataLlaveModel[]>(
                    result.data!.map(DataLlaveModel.deserialize)
                );
            }
            return Recurso.fromError<DataLlaveModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<DataLlaveModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getLlavesPorExpirar(): Promise<Recurso<DataLlaveModel[]>> {
        try {
            const result = await this.dataSource.getLlavesPorExpirar();

            if (result.isSuccess()) {
                return Recurso.fromData<DataLlaveModel[]>(
                    result.data!.map(DataLlaveModel.deserialize)
                );
            }
            return Recurso.fromError<DataLlaveModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<DataLlaveModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getEstadoLlavesAnual(input: GetEstadoLlavesAnualParams): Promise<Recurso<EstadoLlaveAnualModel[]>> {
        try {
            const result = await this.dataSource.getEstadoLlavesAnual(input);

            if (result.isSuccess()) {
                return Recurso.fromData<EstadoLlaveAnualModel[]>(
                    result.data!.map(EstadoLlaveAnualModel.deserialize)
                );
            }
            return Recurso.fromError<EstadoLlaveAnualModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<EstadoLlaveAnualModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getResumenLlaves(input: FechaParams): Promise<Recurso<ResumenByClienteProductoUsuarioModel[]>> {
        try {
            const result = await this.dataSource.getResumenLlaves(input);

            if (result.isSuccess()) {
                return Recurso.fromData<ResumenByClienteProductoUsuarioModel[]>(
                    result.data!.map(ResumenByClienteProductoUsuarioModel.deserialize)
                );
            }
            return Recurso.fromError<ResumenByClienteProductoUsuarioModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<ResumenByClienteProductoUsuarioModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }
}